import {createOrder,deleteOrder,listDataOrder} from "@/zsm-api-new/order.js"
const state = {

}

const mutations = {

}

const actions = {
  // 获取订单列表
  listDataOrder({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      listDataOrder(info).then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 删除订单
  deleteOrder({
    commit
  }, id) {
    return new Promise((resolve, reject) => {
      createOrder(id).then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  // 创建订单
  createOrder({
    commit
  }, info) {
    return new Promise((resolve, reject) => {
      createOrder(info).then(response => {
          resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
